import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map} from 'rxjs/operators';
import { RootStoreState } from '..';
import { Store } from '@ngrx/store';
import * as ActionPlanList from './action';

@Injectable()
export class PlanListEffects {
  constructor(private store: Store<RootStoreState.State>, private actions$: Actions) {}

  @Effect()
  loadAction$ = this.actions$
    .pipe(
      ofType<ActionPlanList.PostPlanListRequest>(ActionPlanList.POST_PlanList),
      map(action => {return action.payload}),
      
    );
  private handleError(error) {
    return of(new ActionPlanList.Error(error));
  }
}
